/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { call } from 'redux-saga/effects';
import * as Assets from 'core/store/ducks/assets';
import * as Gdpr from 'core/store/ducks/gdpr';
import * as Channels from 'core/store/ducks/epg/channels';
import * as TopChannels from 'core/store/ducks/epg/topChannels';
import * as TunedChannels from 'core/store/ducks/epg/tunedChannels';
import * as Region from 'core/store/ducks/region';
import * as Wishlist from 'core/store/ducks/wishlist';
import * as Consumption from 'core/store/ducks/consumption';
import * as Entitlements from 'core/store/ducks/entitlements';
import * as Recordings from 'core/store/ducks/recordings';
import * as PlaybackLicense from 'core/store/ducks/playbackLicense';
import * as ParentalControl from 'core/store/ducks/parentalControl';
import * as FolderLastWatchedContents from 'core/store/ducks/folderLastWatchedContents';
import * as ContentSettings from 'core/store/ducks/contentSettings';
import * as VodProductIdCache from 'core/store/ducks/vodProductIdCache';

const sagas = [
  call(Assets.saga),
  call(Gdpr.saga),
  call(Channels.saga),
  call(TunedChannels.saga),
  call(Region.saga),
  call(Wishlist.saga),
  ...Consumption.sagas,
  ...Entitlements.sagas,
  ...Recordings.sagas,
  call(TopChannels.saga),
  ...PlaybackLicense.sagas,
  call(TopChannels.saga),
  call(ParentalControl.saga),
  call(FolderLastWatchedContents.saga),
  call(ContentSettings.saga),
  call(VodProductIdCache.saga),
];

export default sagas;
